import { render, staticRenderFns } from "./tejarat.vue?vue&type=template&id=351238ac"
import script from "./tejarat.vue?vue&type=script&lang=js"
export * from "./tejarat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports